<div data-test-id="modal-default" class="modal-window">
  <div class="modal-header">
    <h4 class="modal-title text-truncate w-100" data-test-id="modal-title">
      {{ dislog.title }} {{ 'PROFILE_VIEW_PROFILE_INFO_HINT' | translate }}
    </h4>
    <button
      type="button"
      class="unstyled-button"
      aria-label="Close"
      data-test-id="modal-btn-dismiss"
      (click)="closeDialog()"
    >
      <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
    </button>
  </div>
  <div class="modal-body scroll" data-test-id="wrap-profile-info" (click)="closeDialog()">
    <app-profile-info [fields]="dislog.userInfo"></app-profile-info>
  </div>
  <div class="modal-footer" data-test-id="modal-role-select-footer"></div>
</div>
